import { Icon } from './Icon.tsx';
import { useCountdown } from '../lib/useCountdown.ts';
import { t } from '../lib/strings.ts';

interface Props {
  deadline: string | null | undefined;
  className?: string;
}

/** Live "time remaining" chip. Digits stay LTR via `.num`; labels are Thaana. */
export function CountdownBadge({ deadline, className }: Props): JSX.Element | null {
  const cd = useCountdown(deadline);
  if (!deadline) return null;

  if (cd.passed) {
    return (
      <span className={['inline-flex items-center gap-1.5 text-xs text-destructive', className].filter(Boolean).join(' ')}>
        <Icon name="schedule" size={14} />
        {t.time.passed}
      </span>
    );
  }

  const parts: { value: number; label: string }[] = [];
  if (cd.days > 0) parts.push({ value: cd.days, label: t.time.days });
  parts.push({ value: cd.hours, label: t.time.hours });
  parts.push({ value: cd.minutes, label: t.time.minutes });
  if (cd.days === 0) parts.push({ value: cd.seconds, label: t.time.seconds });

  return (
    <span className={['inline-flex items-center gap-1.5 text-xs text-muted-foreground', className].filter(Boolean).join(' ')}>
      <Icon name="schedule" size={14} />
      <span>{t.time.remaining}</span>
      <span className="inline-flex items-center gap-1">
        {parts.map((p, i) => (
          <span key={i}>
            <span className="num tabular font-medium text-foreground">{p.value}</span> {p.label}
          </span>
        ))}
      </span>
    </span>
  );
}
